const debounceDecorator = (timeout: number) => {
  let timeoutId: number

  return function debounceDecorator(_, __, descriptor: PropertyDescriptor) {
    const original = descriptor.value

    descriptor.value = function replacementMethod(...args: any[]) {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        return original.apply(this, args)
      }, timeout)
    }

    return descriptor
  }
}
export default debounceDecorator
